import React from 'react';

const TestimonialSection = () => {
  return (
    <section className="bg-white py-12">
      <div className="mx-auto px-4 md:px-8">
        <div className="flex mb-8 justify-center">
          <h2 className="items-center text-3xl md:text-4xl font-bold text-center text-[#2c2087]  border-b-[3px] border-[#2c2087] py-1">
            Voices of Our Students
          </h2>
        </div>

        {/* Testimonial Grid */}
        <div className="grid md:grid-cols-3 gap-6 relative mt-5">
          {/* First Video */}
          <div className="bg-[#0b0c21] hover:bg-[#2e2774] transition drop-shadow-lg overflow-hidden">
            <div className="w-full">
              <img src="assets/header-img.jpg" alt="" className="w-full" />
            </div>
            <div className="relative w-full h-56">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/n5KMfnn3XNQ?si=3fFt5Sr8CUR2D9_f"
                title="YouTube video"
                allowFullScreen
              ></iframe>
            </div>
            <div className="text-white p-4 text-center">
              <p className="text-sm font-medium min-h-[92px]">
                Hear from Nousat Hosen Prince, a citizen of Bangladesh, on his
                transformative journey at{' '}
                <span className="font-bold">SPSU!</span>
              </p>
            </div>
          </div>

          {/* Second Video */}
          <div className="bg-[#0b0c21] hover:bg-[#2e2774] transition  drop-shadow-lg overflow-hidden">
            <div className="w-full">
              <img src="assets/header-img.jpg" alt="" className="w-full" />
            </div>
            <div className="relative w-full h-56">
              <iframe
                className="w-full h-full"
                src="https://www.youtube.com/embed/EYjnCNeghDM?si=cK5yAzuUBIFkmRX_"
                title="YouTube video"
                allowFullScreen
              ></iframe>
            </div>
            <div className="text-white p-4 text-center">
              <p className="text-sm font-medium  min-h-[92px]">
                Hear from Riya Jain, a citizen of India, on her transformative
                journey at <span className="font-bold">SPSU!</span>
              </p>
            </div>
          </div>
          <div className="flex justify-center items-center relative md:absolute right-0 bottom-[-50px]">
            <div className="relative">
              <img
                src="assets/botoom-girl-image.png"
                alt="Alumni"
                className="object-cover"
              />
              <div className="absolute left-[2%] md:left-[40%] bottom-[2%] md:bottom-[15%] bg-[#5140a8] w-[200px] md:w-[230px] h-[200px] md:h-[230px] flex items-center justify-center  text-white rounded-[100%] p-2 text-center shadow-lg">
                <div className="relative flex items-center justify-center rounded-[100%] w-full h-full bg-[#5140a8] text-white border-2 border-dashed border-white">
                  <div className="text-center px-4">
                    <hr className="w-16 border-t-2 border-white mx-auto mb-2" />
                    <p className="text-xl font-light">Join Our</p>
                    <p className="text-3xl font-bold">100000+</p>
                    <p className="text-xl font-light">Successful</p>
                    <p className="text-xl font-light">Alumni</p>
                    <hr className="w-16 border-t-2 border-white mx-auto mt-2" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Alumni Badge Section */}
      </div>
    </section>
  );
};

export default TestimonialSection;
